import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";

export const contactStatusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContactStatuses: builder.query({
      query: () => ({
        url: `contact-status?query=all`,
      }),
      providesTags: ["ContactStatus"],
    }),
  }),
});

export const { useGetContactStatusesQuery } = contactStatusApi;

